import type { Error } from '../types';
import { CONTAIN_NUMBER_REGEXP } from '../utils/regex';

export const mustContainNumber =
  (message?: Error['message']) =>
  (value: string): Error => ({
    valid: !!value && CONTAIN_NUMBER_REGEXP.test(value),
    message
  });
